module.exports = __webpack_public_path__ + "197570fd83215004ba397a2bfa243951.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/apple_2023_chart.png
// module id = 1634
// module chunks = 0